const visibility = 'SCROLL_SHOW::SET_VISIBILITY';

function setVisibility(y, threshold) {
  return {
    type: visibility,
    y,
    threshold
  };
}

export default {
  setVisibility,
  visibility
};


// WEBPACK FOOTER //
// ./src/components/scroll-show/actions.js